import styles from '../../../styles/loading.module.css';

export const TerminalLoading: React.FC = () => (
	<div className={styles.spinner}></div>
);
